import { render } from "./FileSize.vue?vue&type=template&id=df7cde20"
import script from "./FileSize.vue?vue&type=script&lang=js"
export * from "./FileSize.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__